import {RequestAnfrage} from "../../model/request.anfrage";
import {FinanzierungsTyp, ResultData} from "../interfaces/result-data.interface";
import {FinanzierungInput} from "../interfaces/result-input.interface";

/**
 * Class holds all the data of the request inside the moderat that the user needs for the frontend.
 */
export class ModeratAnfrage implements RequestAnfrage {

  /**
   * the three different paths on this advisors
   */
  public static readonly PATH_EXPLO = "explo";
  public static readonly PATH_SPEZI = "spezi";

  /**
   * paths of the moc. either the user comes from wpchech or starts inside the moc
   */
  static readonly MODE_STANDARD = '';
  static readonly MODE_WPCHECK = 'wpcheck';

  /**
   * holds the last update we did on the local data
   */
  lastupdate: number;

  /**
   * Holds the last (location) path that the user has seen.
   */
  lastPath: string;

  /**
   * the main interest
   */
  interesse: string = null;

  /**
   * list of measures if interes is 'massnahme'
   */
  interesseMassnahmen: string = "";

  /**
   * Input of the first chapter
   */
  verbrauchsanalyseInput: any = {};

  /**
   * The calculated result for the first chapter
   */
  verbrauchsanalyseResult: any = {};

  /**
   * Input of the second chapter
   */
  bestandsanalyseInput: any = {};

  /**
   * List of extra fields that are requested in some partner portals.
   */
  extraFields: any = {};

  /**
   * Selected measures on the meeasure page
   */
  massnahmen: any = {};

  /**
   * Holds the input of the financial part
   */
  finanzierungInput: FinanzierungInput = {};

  /**
   * Selected financing
   */
  finanzierungsArt: FinanzierungsTyp = null;

  /**
   * costs, set by the user for the measures
   */
  massnahmenKosten: { [key: string]: number } = {};

  /**
   * result of the user's dialog registration
   */
  dialogResult: string;

  /**
   * Holds the result from the measure calculation
   */
  measureResult: ResultData | null;

  /**
   * holds the currecnty active portalId for this request
   */
  portalId: string;

  /**
   * Holds the campaignid which is used by tracking or external partners
   */
  campaignId: string = null;

  /**
   * path in logic
   */
  mode: string = ModeratAnfrage.MODE_STANDARD;

  /**
   * Flag to show the hint for the cost changes
   */
  showCostChangeHint: boolean = false;

  /**
   * save the case of cost changes on result page
   */
  hasCostsChanged: boolean = false;

  /**
   * Toggle for showing the step address in the input area of verbrauchsanalyse. True only if the
   * portal config enables it AND the user's current energy source is not already district heating
   * (energietraeger_name !== 'fernwaerme'). Also controls whether the fernwaerme teaser is shown
   * on the result page.
   */
  showStepAddress: boolean = false;

  /**
   * True if the request was started directly on the first chapter (?step=chapter1). The entry page is then not
   * offered as previous step anymore.
   */
  hideEntry: boolean = false;

  /**
   * Returns the user path ion the advisor, based on its first selection
   */
  getPath(): string {
    if(this.interesse === 'massnahme') {
      return ModeratAnfrage.PATH_SPEZI;
    }
    return ModeratAnfrage.PATH_EXPLO;
  }

  /**
   * Resets the usr selection of measures and costs
   */
  resetMeasureSelectionAndCosts(resetMesaures: boolean): void {
    // reset userinputs
    this.massnahmenKosten = {};

    if(resetMesaures === true) {
      this.massnahmen = {};
    }
  }
}
